import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { useSettings } from '../context/SettingsContext';
import api from '../services/api';

export default function Footer() {
  const { settings } = useSettings();
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get('/services')
      .then(res => setServices(res.data))
      .catch(err => console.error('Services fetch error:', err));
  }, []);

  const firstFive = services.slice(0, 5);
  const nextFive = services.slice(5, 10);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* About Column */}
          <div className="footer-col">
            <h4>{settings.site_title || 'Site'}</h4>
            <p>{settings.address || ''}</p>
            <div className="social-links">
              {settings.facebook && (
                <a href={settings.facebook} target="_blank" rel="noopener noreferrer">
                  <FaFacebook />
                </a>
              )}
              {settings.instagram && (
                <a href={settings.instagram} target="_blank" rel="noopener noreferrer">
                  <FaInstagram />
                </a>
              )}
            </div>
          </div>

          {/* Services Column 1 */}
          <div className="footer-col">
            <h4>Hizmetler</h4>
            {firstFive.map((service) => (
              <Link key={service.id} to={`/hizmetler/${service.slug}`}>
                {service.title}
              </Link>
            ))}
          </div>

          {/* Services Column 2 */}
          <div className="footer-col">
            <h4>Hizmetler</h4>
            {nextFive.map((service) => (
              <Link key={service.id} to={`/hizmetler/${service.slug}`}>
                {service.title}
              </Link>
            ))}
          </div>

          {/* Contact Column */}
          <div className="footer-col">
            <h4>İletişim</h4>
            {settings.phone && (
              <p>
                <FaPhone style={{ marginRight: 8 }} />
                {settings.phone}
              </p>
            )}
            {settings.email && (
              <p>
                <FaEnvelope style={{ marginRight: 8 }} />
                {settings.email}
              </p>
            )}
            {settings.address && (
              <p>
                <FaMapMarkerAlt style={{ marginRight: 8 }} />
                {settings.address}
              </p>
            )}
          </div>
        </div>

        <div className="footer-bottom">
          <p>{settings.footer_text || `© ${new Date().getFullYear()} ${settings.site_title || 'Site'}. Tüm hakları saklıdır.`}</p>
        </div>
      </div>
    </footer>
  );
}
